<template>
  <div class="wrap">
    <header  style="    display: flex;justify-content: center;">
      <span style="position: absolute;left: 20px;"  class="iconfont icon-back-left" @click="goBack"></span>
      <h2 >{{lang.recharge}}</h2>
    </header>
    <div class="main">
      <!-- <div class="list">
        <p class="blc">{{userInfo.blc}}</p>
        <p class="tit">{{lang.curcoin}}</p>
      </div> -->
      <div class="list">
        <p class="title">{{lang.channels}}</p>
        <div class="chanbox">
<!--          <div class="chanlist" v-for="item in payList" :key="item.id">-->
<!--            <p class="chanMethod" @click="chosePay(item)">-->
<!--              <span>-->
<!--                <b>{{item.name}}</b>-->
<!--                <i>{{lang.jefw}}: {{ item.ds_min }} ~ {{item.ds_max}}</i>-->
<!--              </span>-->
<!--              <span class="iconfont" :class="[formData.api==item.id?'icon-31xuanzhong':'icon-xuanzhong']"></span>-->
<!--            </p>-->
<!--            <p class="chanTD" :class="{'active':formData.api==item.id}">-->
<!--              <span-->
<!--                @click="formData.chan=e.chan"-->
<!--                v-for="(e,i) in chans[item.id]"-->
<!--                :key="i"-->
<!--                :class="{'active':formData.chan==e.chan}">-->
<!--                {{e.chanName}}-->
<!--              </span>-->
<!--            </p>-->
<!--          </div>-->
          <div class="chanlist"  v-for="item in payList" :key="item.id">
            <div v-if="item.type == 1" class="chanMethod" @click="selectAddr(item)">
              <div style="display: flex;justify-content: space-between;">
                <span>USDT</span>
                <span class="iconfont" :class="[formData.api==item.id ?'icon-31xuanzhong':'icon-xuanzhong']"></span>
              </div>
              <div :class="formData.api !=item.id ? 'displayNone':''" style="display: flex;justify-content: space-between;">
                <span style="font-size: 12px;opacity: 0.7;">TRC20: {{item.Addr}}</span>
                <i :class="['tag-read'+item.id ,'iconfont' ,'icon-fuzhi']" style="margin-left: 10px" :data-clipboard-text="item.Addr" @click="copydz('.tag-read'+item.id)"></i>
              </div>
            </div>
            <div v-if="item.type == 2" class="chanMethod" @click="selectAddr(item)">
              <div style="display: flex;justify-content: space-between;">
                <span>USDT</span>
                <span class="iconfont" :class="[formData.api==item.id ?'icon-31xuanzhong':'icon-xuanzhong']"></span>
              </div>
              <div :class="formData.api !=item.id ? 'displayNone':''" style="display: flex;justify-content: space-between;">
                <span style="font-size: 12px;opacity: 0.7;">ERC20: {{item.Addr}}</span>
                <i :class="['tag-read'+item.id ,'iconfont' ,'icon-fuzhi']" style="margin-left: 10px" :data-clipboard-text="item.Addr" @click="copydz('.tag-read'+item.id)"></i>
              </div>
            </div>
<!--            <div v-if="item.type == 2" class="chanMethod" style="display: flex" @click="formData.api=item.id">-->
<!--              <span>-->
<!--                <b>ERC20</b>-->
<!--                <i>{{lang.jefw}}: {{ item.ds_min }} ~ {{item.ds_max}}</i>-->
<!--              </span>-->
<!--              <span class="iconfont" :class="[formData.api==item.id ?'icon-31xuanzhong':'icon-xuanzhong']"></span>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div id="qrcodeDom" ></div>
      <div class="addr" v-if="addr != ''">
        {{addr}}
        <i class="tag-read iconfont icon-fuzhi" style="margin-left: 10px" :data-clipboard-text="addr" @click="copydz('.tag-read')"></i>
      </div>
      <div class="list">
        <p class="title">{{lang.amount}}</p>
        <label class="inputbox">
          <span>{{currSymbol}}</span>
          <input type="tel" :placeholder="lang.endepm" v-model="formData.amt"/>
<!--          <span style="    font-size: 14px;color: #000;margin-left: 10px;">  = USDT: {{ amtToUSDT }} </span>-->
        </label>
        <p class="tit">{{lang.quickSelection}}</p>
        <p class="moneybox">
          <span v-for="i in moneyArr" :key="i" @click="formData.amt=i" :class="{'active':formData.amt==i}">{{i}}</span>
        </p>
      </div>
      <div class="btn" @click="deposited">{{lang.confirm}}</div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { CONF } from '@/assets/js/config'
import Clipboard from 'clipboard';
  import {
    mapState
  } from 'vuex'
import router from "../../router";
import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        currSymbol: CONF.CURR_SYMBOL,
        payList: [],
        chans:{},
        USDT:{},
        api: '',
        addr: '',
        digit:'',
        moneyArr:[],
        paychan:'',
        formData: {
          amt: '', //金额
          api: '', //apiID
          chan: ''
        },
        formAction: '',
        formMethod: '',
        formInput: '',
      }
    },
    mounted() {
      // this.newsList = this.newsList.concat(this.newsList);
      // let newsBox = document.getElementById("newsBox");
      // setInterval(() => {
      //   if (newsBox.scrollTop >= newsBox.scrollHeight / 2) {
      //     newsBox.scrollTop = 0;
      //   } else {
      //     newsBox.scrollTop++;
      //   }
      // }, 50);
    },
    created() {
      this.getPayList();
    },
    computed: {
      ...mapState(['userInfo', 'lang']),
      amtToUSDT() {
        // `this` 指向当前组件实例
        return (this.formData.amt / 7).toFixed(2);
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getPayList() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/pay/apis')
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.payList = res.data.data.apis;
              this.chans = res.data.data.chans;
              this.moneyArr = res.data.data.qkAmt;
              this.USDT = JSON.parse(res.data.data.USDT)
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              localStorage.setItem('tk', res.data.tk);
              router.push("login")
            } else if (res.data.err == 106) {
              this.$router.push('Login');
              localStorage.setItem('tk', res.data.tk);
              router.push("login")
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
          })
      },
      chosePay(item){
        this.formData.api = item.id;
        if (this.chans[item.id]&&this.chans[item.id].length) {
          this.formData.chan = this.chans[item.id][0].chan;
        }
        // let chan = JSON.parse(item.chan);
        // let chan = this.chans[item.id]||{};
        // if(chan.length){
        //   for(let i = 0; i < chan.length; i++){
        //     if(chan[i][2]==1){
        //       this.formData.chan = chan[i][0];
        //       break;
        //     }
        //   }
        // }else{
        //   this.formData.chan = '';
        // }
        this.digit = item.digit;
      },
      creatForm(method, url, data) {
        this.formAction = url;
        this.formMethod = method;
        this.formInput = '';
        for (let i in data) {
          this.formInput += '<input type="hidden" name="' + i + '" value="' + data[i] + '">'
        }
        this.$nextTick(() => {
          document.forms[0].submit();
        })
      },
      deposited() {
        if (!this.formData.api||isNaN(this.formData.api)) {
          this.$messagebox({
            title: this.lang.tip,
            message: this.lang.chosepay,
            confirmButtonText: this.lang.confirm
          });
          this.formData.amt = '';
          return false;
        }
        if (!this.formData.amt||isNaN(this.formData.amt)) {
          this.$messagebox({
            title: this.lang.tip,
            message: this.lang.endepm,
            confirmButtonText: this.lang.confirm
          });
          this.formData.amt = '';
          return false;
        }
        if (Number(this.formData.amt) > Number(this.max) || Number(this.formData.amt) < Number(this.min)) {
          this.$messagebox({
            title: this.lang.tip,
            message: this.lang.errm,
            confirmButtonText: this.lang.confirm
          });
          return false;
        }
        this.formData.amt = Number(this.formData.amt).toFixed(2);
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/pay/deposit', {
            ...this.formData
          })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              if (res.data.reqUrl) {
                window.location.href = res.data.reqUrl;
              }else{
                this.$toast({
                  message: res.data.msg,
                  iconClass: "iconfont icon-chenggong",
                  duration: 2000,
                });
                setTimeout(() => {this.$router.push("/");}, 2000);
              }
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              localStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
          })
      },
      copydz(name) {
        var clipboard = new Clipboard(name)
        clipboard.on('success', e => {
          this.$toast({
            message: this.lang.copysucc,
            position: 'middle',
            iconClass: 'iconfont icon-chenggong'
          });
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          this.$toast({
            message: this.lang.copyDefault,
            position: 'middle',
            iconClass: 'icon icon-shibai'
          });
          // 释放内存
          clipboard.destroy()
        })
      },
      selectAddr(item){
        this.formData.api=item.id;
        this.addr = item.Addr
        this.urlAddr()
      },
      urlAddr(){
        document.getElementById('qrcodeDom').innerHTML='';
        new QRCode('qrcodeDom',{
          width: 120,
          height:120,
          text: this.addr//需要转换的链接
        })
      }
    },
  }
</script>
<style type="text/css"  scoped>
  .list{
    position: relative;
    margin: 12px;
    padding:12px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 3px 5px rgba(197, 197, 197, .5);
  }
  .blc{
    margin:5px 12px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    padding-bottom:10px;
    border-bottom:1px solid #eee;
    color:#fd574f;
  }
  .tit{
    font-size: 12px;
    color:#999;
    text-align: center;
  }
  .title{
    padding-bottom:10px;
    font-weight: bold;
  }
  .chanbox{
    padding:10px 0;
    border-top:1px solid #eee;
  }
  .chanbox .chanlist{
    margin-top:10px;
  }
  .chanbox .chanlist .chanMethod{
    display: block;
    justify-content: space-between;
    align-items: center;
  }
  .chanbox .chanlist .chanMethod span:first-child{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .chanbox .chanlist .chanMethod span:first-child b{
    font-weight: normal;
  }

  .chanbox .chanlist .chanMethod span:first-child i{
    font-size: 12px;
    color:#999;
  }

  .icon-check{
    font-size:24px;
    vertical-align: middle;
    color:#999;
  }

  .icon-31xuanzhong{
    color:#44dc98;
    font-size:24px;
  }

  .chanbox .chanlist .chanTD{
    max-height: 0;
    margin:0 10px;
    display: flex;
    flex-wrap:wrap;
    justify-content: space-between;
    overflow: hidden;
  }
  .chanbox .chanlist .chanTD.active{
    transition: all ease 1s;
    max-height: 500px;
  }

  .chanbox .chanlist .chanTD span{
    width:46%;
    padding:5px 10px;
    border:1px solid #eee;
    border-radius: 5px;
    color:#666;
    text-align: center;
    margin-top: 10px;
  }
  .chanbox .chanlist .chanTD span.active{
    color:#fff;
    background: #0183FF;
    border:1px solid #0183FF;
  }

  .inputbox{
    display: flex;
    align-items: center;
    margin-bottom:10px;
  }
  .inputbox span{
    font-size: 24px;
    color:#0183FF;
    margin-right:12px;
    font-weight: bold;
  }
  .inputbox input{
    flex:1;
    height: 34px;
    max-width: 40%;
    line-height: 34px;
    border-radius: 5px;
    background: #ecf1ff;
    color:#0183FF;
    padding-left:12px;
    font-weight: bold;
  }
  .moneybox{
    display: flex;
    flex-wrap: wrap;
  }
  .moneybox span{
    width:100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 13px;
    font-weight: bold;
    border:1px solid #0183FF;
    border-radius: 5px;
    margin-top:10px;
    margin-left:7px;
  }
  .moneybox span.active{
    color:#fff;
    background: #0183FF;
  }

  .usdt-list{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
  }
  .usdt-list span:nth-child(2) {
    margin-left: 10px;
  }


  .btn {
    margin: 30px 30px 0;
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    font-size: 16px;
    background: #3476FE;
  }
  .formbox {
    width: 0;
    height: 0;
    opacity: 0;
  }

  .newsBox {
    margin: 12px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 3px 5px rgba(197, 197, 197, 0.5);
    padding: 10px;
  }
  #newsBox {
    height: 100px;
    overflow: hidden;
  }
  #newsBox .newsList {
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
  }
  #newsBox .newsList p {
    text-align: center;
  }
  #newsBox .newsList p span:first-child {
    margin: 0 10px;
  }

  #newsBox .newsList p .red {
    color: #fd574f;
  }
  .displayNone{
    display: none!important;
  }
#qrcodeDom{
    display: flex;
    align-items: center;
    justify-content: center
}
.addr{
  text-align: center;
  margin: 10px;
}
</style>